module.exports = __webpack_public_path__ + "files/394852afb11098f255aaf257ae3d2b27.png";